import React, {useState} from 'react';
import Input from 'components/common/Form/Input';
import {ShowPassIcon} from 'components/common/icons';

let timer = null;

export default function Password(props) {
    const [type, changeType] = useState('password');

    const toggleType = () => {
        clearTimeout(timer);

        if (type === 'password') {
            changeType('text');
            timer = setTimeout(() => changeType('password'), 5000);
            return;
        }

        changeType('password');
    };

    return (
        <Input
            {...props}
            type={type}
            btnClass='showPassBtn'
            onBlur={() => changeType('password')}
            customBtn={btnProps => <ShowPassIcon onClick={toggleType} {...btnProps} />}
            showBtn={props.value !== ''}
        />
    );
}
